import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";

const radio = "radio";
const checkbox = "checkbox";

export interface Props {
  label?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  checked?: boolean;
  isRadio?: boolean;
  boxSize?: "default" | "large";
  labelClassname?: string;
  checkboxClassname?: string;
  checkedClassName?: string;
}

class Selector extends React.PureComponent<Props> {
  public render() {
    const {
      label,
      onChange,
      disabled,
      checked,
      isRadio,
      boxSize = "default",
      labelClassname,
      checkboxClassname,
      checkedClassName,
    } = this.props;

    const checkboxClassName = classNames(
      styles.checkbox,
      {
        [styles.disabled]: disabled,
        [checkedClassName ? checkedClassName : styles.checked]: checked,
      },
      checkboxClassname,
    );

    const radioClassName = classNames(styles.radio, styles[boxSize], {
      [styles.disabled]: disabled,
      [styles.checkedRadio]: checked,
    });

    return (
      <label className={styles.main}>
        <input
          className={styles.input}
          disabled={disabled}
          type={isRadio ? radio : checkbox}
          onChange={onChange}
          checked={checked}
          readOnly={!onChange}
        />
        <div className={isRadio ? radioClassName : checkboxClassName} />
        <div
          className={classNames(
            disabled ? styles.labelDisabled : styles.label,
            labelClassname,
          )}
        >
          {label}
        </div>
      </label>
    );
  }
}

export { Selector, radio };
